import React from "react";
import { ShieldCheck } from "lucide-react";

/**
 * Compact "Lab Verified" trust badge. Renders in two sizes:
 *   - "sm"  (default) — used on ProductCard grid tiles
 *   - "lg"  — used on ProductDetail page
 *
 * Displays a checkmark shield + "LAB VERIFIED" label + hover tooltip explaining
 * what the badge means. Boosts on-page trust + click-through in search results.
 */
const EXCLUDED = new Set(["blue-renewal"]);

export default function LabVerifiedBadge({ size = "sm", className = "", slug }) {
  if (EXCLUDED.has(slug)) return null;
  if (size === "inline") {
    return (
      <div
        data-testid="lab-verified-badge"
        className="flex items-center gap-1.5 font-mono-tech uppercase text-[8px] sm:text-[9px] tracking-[0.04em] sm:tracking-[0.12em] text-[#7FA8C9]"
      >
        <ShieldCheck size={11} className="shrink-0 text-[#00C3FF]" />
        <span className="leading-snug">HPLC/Mass Spectrometry Verified</span>
      </div>
    );
  }
  const isLg = size === "lg";
  return (
    <span
      title="Every batch is third-party verified by HPLC and Mass Spectrometry. Certificate of Analysis available on request."
      data-testid="lab-verified-badge"
      className={
        `inline-flex items-center gap-1.5 font-mono-tech uppercase ` +
        `border border-[#00C3FF]/50 bg-[#07070D]/90 backdrop-blur-sm text-[#00C3FF] transition-colors hover:bg-[#0C1A26] ` +
        (isLg ? "px-3 py-1.5 text-[10px] tracking-[0.16em]" : "px-1.5 py-1 text-[7px] sm:text-[9px] tracking-[0.08em] sm:tracking-[0.16em] max-w-[130px] sm:max-w-[160px] leading-tight text-left") +
        " " + className
      }
    >
      <ShieldCheck size={isLg ? 13 : 11} className="shrink-0" />
      HPLC/Mass Spectrometry Verified
    </span>
  );
}
